import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import SkeletonPulse from '../SkeletonPulse';
/**
 * SkeletonLine renders a line that simulates text loading.
 * Check RecentReviews for a complete example.
 */

var Skeleton = styled(SkeletonPulse).withConfig({
  displayName: "SkeletonLine__Skeleton",
  componentId: "sc-a0kufc-0"
})(["\n  ", ";\n  border-radius: 3px;\n\n  /* This will add a blank space inside the element so that the\n   * gray pulse takes up the line height of the parent\n   * without needing to explicitly set the height of the element.\n   */\n  &::before {\n    content: '", "';\n  }\n"], _ref => {
  var $width = _ref.$width,
      $height = _ref.$height;
  return css(["\n    ", "\n    ", "\n  "], $width && $width.toString().length > 0 && css(["\n      width: ", ";\n    "], typeof $width === 'number' ? "".concat($width, "px") : $width), $height && $height.toString().length > 0 && css(["\n      height: ", ";\n    "], typeof $height === 'number' ? "".concat($height, "px") : $height));
}, '\u2003');
export default function SkeletonLine(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      rest = _objectWithoutProperties(_ref2, ["width", "height"]);

  return /*#__PURE__*/React.createElement(Skeleton, _extends({
    $width: width,
    $height: height
  }, rest));
}
SkeletonLine.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};